export enum RiskRegisterCardSlotOption {
    None = "None",
    ExposureBand = "ExposureBand",
    Likelihood = "Likelihood",
    HealthRisk = "HealthRisk",
    En689Compliance = "En689Compliance",
    RiskRating = "RiskRating",
    ConsequenceRating = "ConsequenceRating",
    PostTreatmentScore = "PostTreatmentScore",
    NumberOfSamples = "NumberOfSamples",
    Status = "Status",
}

export const RiskRegisterCardSlotOptionLabels: Record<RiskRegisterCardSlotOption, string> = {
    [RiskRegisterCardSlotOption.None]: "None",
    [RiskRegisterCardSlotOption.ExposureBand]: "Exposure Band",
    [RiskRegisterCardSlotOption.Likelihood]: "Likelihood",
    [RiskRegisterCardSlotOption.HealthRisk]: "Health Risk",
    [RiskRegisterCardSlotOption.En689Compliance]: "EN 689 Compliance",
    [RiskRegisterCardSlotOption.RiskRating]: "Risk Rating",
    [RiskRegisterCardSlotOption.ConsequenceRating]: "Consequence Rating",
    [RiskRegisterCardSlotOption.PostTreatmentScore]: "Post-Treatment Score",
    [RiskRegisterCardSlotOption.NumberOfSamples]: "Number of Samples",
    [RiskRegisterCardSlotOption.Status]: "Status",
};

export enum RiskRegisterCardColorScale {
    Likelihood = "Likelihood",
    RiskLevel = "RiskLevel",
    Compliance = "Compliance",
}
